import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/core/services/http/http.service';
import { EndPoints } from 'src/app/shared/EndPoints';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LegalInfoService {

  private CPBaseUrl: string;

  constructor(private httpService: HttpService) {
    this.CPBaseUrl = environment.customerPortalServiceUrl;
  }

  public getLatestPrivacyPolicy(domainName: string) {
    return this.httpService.Get(`${this.CPBaseUrl}${EndPoints.privacyPolicy}/${domainName}`);
  }

  public getLatestOrderingPhysicianSignatureContent() {
    return this.httpService.Get(`${this.CPBaseUrl}${EndPoints.orderingPhysicianContent}`);
  }

  public getLatestTermsOfUse(domainName: string) {
    return this.httpService.Get(`${this.CPBaseUrl}${EndPoints.termsOfUse}/${domainName}`);
  }

  public getLatestContactInfo(domainName: string) {
    return this.httpService.Get(`${this.CPBaseUrl}${EndPoints.GET_CONTACT_SUPPORT}/${domainName}`);
  }

 public getBuNavigationLink(domainName: string){
    return this.httpService.Get(`${this.CPBaseUrl}${EndPoints.buNavigationLink}/${domainName}`);
  }

  public getLatestEurofinsSupport(domainName: string){
    return this.httpService.Get(`${this.CPBaseUrl}${EndPoints.eurofinsSupport}/${domainName}`);
  }

  public getLatestEurofinsSupportForBulkExport(domainName: string) {
    return this.httpService.Get(`${this.CPBaseUrl}${EndPoints.eurofinsSupportForBulkExport}/${domainName}`);
  }

 
  public getPolicyAcceptanceDetail() {
    const url = `${this.CPBaseUrl}${EndPoints.policyAcceptanceDetail}`;
    return this.httpService.Get(url);
  }

  public UpdatePolicyDetail(userId: string, policyName: string) {
    const url = `${this.CPBaseUrl}${EndPoints.updatePolicyDetail}?policyName=${policyName}`;
    return this.httpService.Post(url, null);
  }

  public contactSupport(contactData: object) {
    const url = `${this.CPBaseUrl}Email/ContactSupport`;
    return this.httpService.Post(url, contactData);
  }
}
